/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

export const environment = {
  production: true,
  disableHttpsCheck: false,
  apiUrl: "https://api.sg.g17.eco",
  oktaIssuer: "https://login.g17.eco/oauth2/aus1d5wrn6Bk6KPC0417",
  oktaClientId: "0oa34e3545W1ZS0Ap417",
  envConfig: {
    stage: "Production",
    location: "Singapore",
    classname: "production",
  },
  allowUserPermissions: false,
};
